import useBookingFlowRedesign from "hooks/useBookingFlowRedesign";
import React from "react";
import { ReactComponent as Clock } from "../../assets/images/stopwatch.svg";
import HpvServicePageV2 from "./hpv-service-v2";
import {
    Button,
    Footer,
    Header,
    OptionDetail,
    RadioCardExpanded,
} from "../../components";
import useLanguage from "../../hooks/language";
import "./hpvServicePage.css";

export default function HpvServicePage({
    onSubmit,
}: {
    onSubmit: () => void;
}): React.ReactElement {
    const isBookingFlowRedesign = useBookingFlowRedesign();
    const { translations } = useLanguage();

    if (isBookingFlowRedesign) {
        return <HpvServicePageV2 onSubmit={onSubmit} />;
    }

    const onSelect = () => {
        //no select handler required, there is only one choice
    };

    return (
        <div className="page">
            <Header />
            <div className="hpv-service-page__container">
                <h1 className="hpv-service-page__title">
                    {translations.hpvServicePage.title}
                </h1>
                <div className="hpv-service-page__description">
                    {translations.hpvServicePage.description}
                </div>
                <div className="hpv-service-page__turnaround-content">
                    <RadioCardExpanded
                        checked={true}
                        name="hpvService"
                        value="hpv"
                        onSelect={onSelect}
                        icon={<Clock />}
                    >
                        <div className="hpv-service-page__turnaround-card-content">
                            <span className="hpv-service-page__turnaround-card-title">
                                {translations.hpvServicePage.details.title}
                            </span>
                            <div>
                                <OptionDetail
                                    text={
                                        translations.hpvServicePage.details
                                            .info1
                                    }
                                    sup="1"
                                />
                                <OptionDetail
                                    text={
                                        translations.hpvServicePage.details
                                            .info2
                                    }
                                />
                            </div>
                            <span className="hpv-service-page__turnaround-card-subtitle">
                                {translations.hpvServicePage.details.price}{" "}
                                <span className="hpv-service-page__turnaround-card-note">
                                    {
                                        translations.hpvServicePage.details
                                            .priceNote
                                    }
                                </span>
                            </span>
                        </div>
                    </RadioCardExpanded>
                </div>

                <Button
                    type="primary"
                    onClick={onSubmit}
                    className="hpv-service-page__button"
                >
                    {translations.hpvServicePage.button}{" "}
                </Button>
                <div className="hpv-service-page__footnote-container">
                    <span className="hpv-service-page__footnote-text">
                        {translations.hpvServicePage.details.footnote}
                    </span>
                </div>
            </div>
            <Footer />
        </div>
    );
}
